import React,{useState, useEffect} from 'react';
import {databaseUrl} from '../../server/server.js';
import { useLocation } from 'react-router-dom';

import { Button } from '@mui/material';
import axiosInstance from '../../server/axios.js';

const NotApproch = () => {
  const location = useLocation();
  const idList = location.search.split('=')[1];

  const [id, setId] = useState('');
  const [inputdate, setInputDate] = useState('');
  const [due_date, setDueDate] = useState('');
  const [delivery_date, setDeliveryDate] = useState('');
  const [material, setMaterial] = useState('');
  const [material_weight, setMateraiWeight] = useState('');
  const [note, setNote] = useState('');
  const [order_company, setOrderCompany] = useState('');
  const [stop, setStop] = useState('');


  useEffect(() => {getdata()}, [])

  const getdata =async () => {
    const response = await axiosInstance.get(`${databaseUrl}/orderboard/find?id=${idList}`);
/*
  delivery: "미정"
  delivery_date: "2026-07-03"
  deposit: "X"
  deposit_day: ""
  deposit_price: 0
  deposit_send: " "
  due_date: "2026-06-22T00:00:00.000Z"
  hide: "N"
  id: 7765
  inputdate: "2026-06-18T11:13:44.000Z"
  material: "PNC 400"
  material_code: "090101827029"
  material_price: 0
  material_weight: "2"
  note: "9229 배송:인천공장 "
  order_company: "(주)엘지생활건강"
  order_company_code: "00150"
  position: " "
  purchaser: ""
  purchaser_code: ""
  result: "X"
  sorting: null
  statement: "2026-06-21T15:00:00.000Z"
  stop: "1"
  username: "장세희"
*/
    setId(response.data.id);
    setInputDate(response.data.inputdate);
    setDueDate(response.data.due_date);
    setDeliveryDate(response.data.delivery_date);
    setMaterial(response.data.material);
    setMateraiWeight(response.data.material_weight);
    setNote(response.data.note);
    setOrderCompany(response.data.order_company);
    setStop(response.data.stop);  

  }
  const clickOrderday = (event) => {
    setDeliveryDate(event.target.value);
  }
  const changeData = async () => {
    //console.log(id,delivery_date);
    const sendData = await axiosInstance.get(`${databaseUrl}/orderboard/notapproch?id=${id}&chdate=${delivery_date}&stop=0`);
    if(sendData.data === 'ok'){
      window.open('','_self').close(); 
    }else{
      alert('Error');
      window.open('','_self').close(); 
    }
  }

    return (
        <>
        {id}                 {stop}
        <table border={1} style={{borderCollapse:'collapse',border:'1px solid black'}}>
          <thead>
            <tr>
              <th colSpan={7}>입고 후 출고 원료 변경</th>
            </tr>
            <tr>
              <th style={{minWidth:'150px'}}>발주사</th>
              <th style={{minWidth:'100px'}}>제품명</th>
              <th style={{minWidth:'100px'}}>kg</th>
              <th>발주일</th>
              <th>납품요청일</th>
              <th style={{backgroundColor:'green',color:'white'}}>납품예정일</th>
              <th style={{minWidth:'100px'}}>비고</th>
            </tr>
          </thead>
          <tbody>
          <tr>
            <td>{order_company}</td>
            <td>{material}</td>
            <td>{material_weight}</td>
            <td>{inputdate.substring(0,10)}</td>
            <td>{due_date.substring(0,10)}</td>
            <td style={{backgroundColor:'green'}}><input type="date" value={delivery_date} className="outputdate" onChange={clickOrderday}/></td>
            <td>{note}</td>
          </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colSpan={7}><Button variant="outlined" color="secondary" style={{width:'100%'}} onClick={()=>changeData()}> 변 경 </Button></td>
            </tr>
          </tfoot>
        </table>
        </>
    )
}
export default NotApproch;

